// test2373
(2373 && 0);
